(() => {
  'use strict';

  const roots = [
    ...document.querySelectorAll('.xc-live-product, [data-xc-tm-product], [data-c500-pdp], .xc-s100-0819, .xc-s300-0820-root, [data-h300-live-product]')
  ];
  if (!roots.length) return;

  const preloadedImages = new Map();

  const parseJson = (node) => {
    if (!node) return [];
    try {
      const value = JSON.parse(node.textContent || '[]');
      return Array.isArray(value) ? value : [];
    } catch (_) {
      return [];
    }
  };

  const imageUrlOf = (variant) => variant?.imageUrl || variant?.image || variant?.src || null;

  const currentVariantIdOf = (root) => {
    const input = root.querySelector('[data-xc-variant-id], [data-xc-tm-variant-id], input[name="id"], [data-variant-id]');
    return input?.value || input?.dataset?.variantId || null;
  };

  const warm = (root) => {
    const data = [
      ...parseJson(root.querySelector('[data-xc-variant-data], [data-xc-tm-variant-data], [data-xc-variant-image-data]'))
    ];
    if (!data.length) return;

    const currentVariantId = currentVariantIdOf(root);
    const urls = [...new Set(
      data
        .filter((variant) => !currentVariantId || String(variant?.id) !== String(currentVariantId))
        .map(imageUrlOf)
        .filter(Boolean)
    )];

    urls.forEach((url) => {
      if (preloadedImages.has(url)) return;
      const image = new window.Image();
      image.decoding = 'async';
      image.fetchPriority = 'high';
      image.src = url;
      preloadedImages.set(url, image);
    });
  };

  const warmImages = () => roots.forEach(warm);
  const scheduleWarmup = () => window.setTimeout(warmImages, 120);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleWarmup, { once: true });
  } else {
    scheduleWarmup();
  }
})();
